import {HTTP_CLIENT} from '../utils/interceptor'
import {Endpoint_registrationApi,Endpoint_AdminregistrationApi} from '../utils/endpoint'

const registrationApi = async (obj)=>{
    const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const body = JSON.stringify(obj); 
    return HTTP_CLIENT.post(Endpoint_registrationApi.registrationApi,body,config)
   
}
const AdminregistrationApi = async (obj)=>{
    const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const body = JSON.stringify(obj); 
    return HTTP_CLIENT.post(Endpoint_AdminregistrationApi.AdminregistrationApi,body,config)
   
}
export {
    registrationApi,
    AdminregistrationApi
}

